import Oboe from 'oboe'

import queryCtrl from '@/utils/query'

import {
  VUEX_API_PHOTOS_FETCH,
  VUEX_API_PHOTOS_FETCH_STREAMING,
  VUEX_API_PHOTOS_FETCH_SUCCESS,
  VUEX_API_PHOTOS_FETCH_FAILED,
  VUEX_API_PHOTOS_ABORT
} from '@/store/constants/api'

import {
  VUEX_TOAST_SHOW
} from '@/store/constants/ui/toast'

let oboeInstance

const state = {
  photosRequest: null,
  photosCancelRequest: null
}

const getters = {}

const actions = {
  // streams one page (skip/limit) of a search: { totalCount } on the first page, then a { row } per product.
  // payload.callback gets { totalCount }, { items }, then { pageDone } or { pageFailed }. Later pages pass
  // expectedRows; the first page works it out from its totalCount
  [VUEX_API_PHOTOS_FETCH_STREAMING]: async ({ state, dispatch, commit }, payload) => {
    try {
      commit(VUEX_API_PHOTOS_FETCH_SUCCESS)
      oboeInstance.abort()
    } catch (error) { /*  */ }

    if (!Object.keys(payload.query).length) return

    let failed = false
    let itemCount = 0
    let expectedRows = payload.expectedRows

    const query = {
      ...payload.query,
      _options: { ...(payload.query._options || {}), skip: payload.skip, limit: payload.limit }
    }

    let queryStr = queryCtrl.qsStringify(query, { arrayFormat: 'indices' })

    await commit(VUEX_API_PHOTOS_FETCH)

    Oboe({
      method: 'GET',
      url: process.env.VUE_APP_API_BASE_URL + '/photos/data?' + queryStr,
      withCredentials: true
    }).on('start', function () {
      oboeInstance = this
    }).node('totalCount', function (totalCount) {
      expectedRows = Math.min(payload.limit, Math.max(totalCount - payload.skip, 0))
      payload.callback({ totalCount: totalCount })
    }).node('row', function (row) {
      if (state.photosRequest !== ITS__API__REQUEST_TYPE__PENDING) {
        this.abort()
        return
      }

      itemCount++
      payload.callback({ items: [Object.freeze(row)] })

      return Oboe.drop
    }).node('!.error', function (message) {
      // a search that fails after the response started comes back as an { error } object in the stream
      failed = true
      commit(VUEX_API_PHOTOS_FETCH_FAILED)
      this.abort()
      payload.callback({ pageFailed: true })

      // stays up until closed, so a stopped search is not missed
      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        persist: true,
        data: {
          type: 'error',
          message: `Cannot return products: ${message}`
        }
      })
    }).on('done', function () {
      // done fires after every top-level object of the multi-json stream, so the page is only
      // complete once all of its rows arrived
      if (failed || state.photosRequest !== ITS__API__REQUEST_TYPE__PENDING) return
      if (expectedRows === undefined || itemCount < expectedRows) return

      commit(VUEX_API_PHOTOS_FETCH_SUCCESS)
      payload.callback({ pageDone: true })
    }).on('fail', function (error) {
      failed = true
      commit(VUEX_API_PHOTOS_FETCH_FAILED)
      payload.callback({ pageFailed: true })

      if (error?.jsonBody?.message) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: `Cannot return products: ${error.jsonBody.message}`
          }
        })
      }
    })
  },

  [VUEX_API_PHOTOS_ABORT]: () => {
    if (oboeInstance) oboeInstance.abort()
  }
}

const mutations = {
  [VUEX_API_PHOTOS_FETCH]: state => {
    state.photosRequest = ITS__API__REQUEST_TYPE__PENDING
  },

  [VUEX_API_PHOTOS_FETCH_SUCCESS]: state => {
    state.photosRequest = ITS__API__REQUEST_TYPE__SUCCESS
  },

  [VUEX_API_PHOTOS_FETCH_FAILED]: state => {
    state.photosRequest = ITS__API__REQUEST_TYPE__FAILED
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
